import React, { useRef, useState, useEffect } from 'react';
import useOutsideClick from '@stencil/use-outside-click';

import DestinationCardUI from './destination-card-ui';
import TopBannerSection from './top-banner-section';
import LoadingListingSection from './loading-listing-section';
import ResetAllFilters from '../Common/reset-all-filters';
import SortBySection from './sort-by-section';
import Footer from './footer';

import * as S from './listing-section.styles';

const ListingSection = ({
  h1header,
  source,
  destinations,
  sortSettings,
  isFilterApplied,
  cityRef,
  countryRef,
  continentRef,
  showDtlSection,
  applySortSettings,
  numberOfDestinations,
  setNumberOfDestinations,
  handleSelectedDestination,
  handleResetFilters,
  handleOpenDtlSection,
  isSEO = false,
  seoData = {},
  isRoundTrip = true
}) => {
  const sortByRef = useRef();
  const destinationCardRef = React.createRef();

  const [showSortby, setsortBy] = useState(
    sortSettings.currentSort == 'cheapest' ? 'CHEAPEST' : 'SHORTEST'
  );
  const [showSortAsc, setSortOrder] = useState(sortSettings?.isAscending);
  const [active, setActive] = useState(false);
  const [totalNumberOfDestinations, setTotalNumberOfDestinations] = useState(
    destinations && destinations.length
  );
  const [showLoader, setShowLoader] = useState(true);
  const [showError, setShowError] = useState(false);
  const [bannerImageUrl, setBannerImageUrl] = useState(
    'https://imgak.goibibo.com/flights-gi-assets/images/dt/destination-picker/random-cover-2.png'
  );

  useEffect(() => {
    setsortBy(sortSettings?.currentSort.toUpperCase());
    setSortOrder(sortSettings?.isAscending);
    handleSelectedDestination({});
    setNumberOfDestinations(10);
  }, [sortSettings.currentSort, sortSettings.isAscending]);

  useEffect(() => {
    // Destinations not available with applied filters
    if (destinations && destinations.length == 0) {
      setShowError(true);
      setShowLoader(false);
    }
    if (destinations && destinations.length > 0) {
      setShowLoader(false);
      setShowError(false);
      setTotalNumberOfDestinations(destinations.length);
    }
    if (destinationCardRef && destinationCardRef?.current?.scrollIntoView) {
      destinationCardRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [destinations]);

  const sortByHandle = e => {
    setsortBy(e);
    setActive(false);
  };

  const handleSortBy = () => {
    setActive(!active);
  };

  const viewAllDestinations = () => {
    setNumberOfDestinations(totalNumberOfDestinations);
  };

  useOutsideClick(sortByRef, () => {
    setActive(false);
  });

  const handleBannerImage = bannerImageUrl => {
    setBannerImageUrl(bannerImageUrl);
  };

  const removeAllFilters = () => {
    setShowError(false);
    handleResetFilters();
  };

  // useOutsideClick(destinationCardRef, () => {
  //   const destinationNode = document.getElementById('destinationsList').childNodes[0];
  //   destinationNode.classList.remove('active');
  //   handleCloseDtlSection();
  // });

  return (
    <S.ListingSection>
      <S.TopBannerSection
        style={{
          backgroundImage: `url(${bannerImageUrl}), url('https://imgak.mmtcdn.com/flights/assets/media/dt/destination-picker/random-cover-2.png?v=2')`
        }}
        className="open"
      >
        <TopBannerSection h1header={h1header} />
      </S.TopBannerSection>
      <S.Container>
        {showLoader ? (
          <>
            <SortBySection
              sortByRef={sortByRef}
              active={active}
              showSortby={showSortby}
              showSortAsc={showSortAsc}
              setSortOrder={setSortOrder}
              applySortSettings={applySortSettings}
              sortByHandle={sortByHandle}
              handleSortBy={handleSortBy}
            />
            <S.ListingOuter className="marginB10">
              {[...Array(10)].map((item, index) => (
                <LoadingListingSection key={index} />
              ))}
            </S.ListingOuter>
          </>
        ) : !showError ? (
          <S.DestinationsContainer ref={destinationCardRef}>
            <SortBySection
              sortByRef={sortByRef}
              active={active}
              showSortby={showSortby}
              showSortAsc={showSortAsc}
              setSortOrder={setSortOrder}
              applySortSettings={applySortSettings}
              sortByHandle={sortByHandle}
              handleSortBy={handleSortBy}
            />
            <S.ListingOuter className="marginB10" id="destinationsList">
              {destinations &&
                destinations.slice(0, numberOfDestinations).map((destination, i) => {
                  const active = i === showDtlSection ? 'active' : '';
                  return (
                    <DestinationCardUI
                      key={i}
                      index={i}
                      active={active}
                      destination={destination}
                      source={source}
                      isRoundTrip={isRoundTrip}
                      cityRef={cityRef}
                      countryRef={countryRef}
                      continentRef={continentRef}
                      handleSelectedDestination={handleSelectedDestination}
                      handleOpenDtlSection={handleOpenDtlSection}
                      handleBannerImage={handleBannerImage}
                    />
                  );
                })}
              {totalNumberOfDestinations !== numberOfDestinations &&
              totalNumberOfDestinations >= 10 ? (
                <p className="TxtCenter marginB10 marginT10 curPointFlt">
                  <span className="viewAllfliBtn" onClick={viewAllDestinations}>
                    View All Destinations
                  </span>
                </p>
              ) : null}
            </S.ListingOuter>
          </S.DestinationsContainer>
        ) : (
          isFilterApplied && <ResetAllFilters removeAllFilters={removeAllFilters} />
        )}
        {!showError && isSEO && (
          <>
            <Footer footerData={seoData} />
          </>
        )}
      </S.Container>
    </S.ListingSection>
  );
};

export default ListingSection;
